import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class AddSiteReviewDto {
  @Field(t => Int)
  reviewId!: number

  @Field(t => Int)
  userId!: number

  @Field(t => Int, { nullable: true })
  site!: number

  @Field({ nullable: true })
  state?: number

  @Field({ nullable: true })
  link?: string

  @Field({ nullable: true })
  statusReason?: string

  @Field(t => Int, { nullable: true })
  status?: number

  public constructor (data: AddSiteReviewDto) {
    Object.assign(this, data)
  }
}
